import React, { Component } from "react";
import './buttons.css'
import swal from "sweetalert";
import { AuthorizeMeeting } from '../Meet/meet_actions'
import SimpleReactValidator from "simple-react-validator"; 

class MeetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = { password: "", __btnClicked: false }
        this.validator = new SimpleReactValidator();
    }

    componentDidMount() {
        $(".loader-page").addClass("hide");
    }

    componentWillUnmount() {
        $(".loader-page").removeClass("hide");
    }

    __submitPassword = async () => { // Will be Deleted
        if(!this.validator.allValid()){
            this.validator.showMessages();
            this.forceUpdate();
            return ;
        }
        const { password } = this.state;
        const { _roomName, uniquekey, _openDeviceSettings } = this.props;
        const response = await APP.store.dispatch(AuthorizeMeeting({ room_name: _roomName.replace(/\s+/g, '').toLowerCase(), password, uniquekey }));
        if (response.code === 1) {
            _openDeviceSettings(false);
        } else {
            swal({ title: response.response, icon: "error", buttons: true, dangerMode: true, });
        }
    }

    render() {
        const { password, __btnClicked } = this.state;
        this.validator.purgeFields();
        return (
            <div className="guestuser-page-section">
                <div className="container">
                    <a className="guest-user-logo"><img src="public/assets/images/homepagelogo.png" alt="logo" /></a>
                    <h1 className="">Meeting Password</h1>
                    <div className="guest-user-boxes">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="guest-user-img">
                                    <img src="public/assets/images/guest-user-img.png" alt="1" className="img-fluid" />
                                    <p>Need a solution to manage Calls,<br /> Meetings all in a singe app</p>
                                    <a className="get-nxa-now">Get Nxatel Now<i class="fas fa-arrow-circle-right ml-2"></i></a>
                                </div>
                            </div>
                            <div className="col-md-2"></div>
                            <div className="col-md-4">
                                <div className=" guest-user-join-form">
                                    <div className="form-group mb-3 mb-1">
                                        <input type="password" className="form-control " placeholder="Enter meeting password" name="password" value={password} onChange={e => this.setState({ password: e.target.value })} />
                                        {this.validator.message('Password', password, 'required')}
                                    </div>
                                    <div className="d-flex justify-content-center guest-user-join-btn-div">
                                        <button type="button" className="btn btn-new-sign bg-back  mr-3" onClick={e => {window.close()}} disabled={__btnClicked}>Back</button>
                                        <button type="button" className="btn btn-new-sign" onClick={e => __btnClicked ? e.preventDefault() : this.__submitPassword()}> {__btnClicked ? "Please wait..." : "Join"}</button>
                                    </div>
                                    <h5>Or Join Meeting on Mobile, Download our App</h5>
                                    <div className="d-flex guest-user-app-dwn-ico justify-content-center">
                                        <a><img src="public/assets/images/Icons App Store Google play 1.png" alt="1" /></a>
                                        <a><img src="public/assets/images/Icons App Store Google play 3.png" alt="1" /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            // <Modal
            //     show={show}
            //     onHide={handleClose}
            //     backdrop="static"
            //     keyboard={false}
            //     size="sm"
            // >
            //     <Modal.Header closeButton>
            //         <Modal.Title>Nxatel Meet Password</Modal.Title>
            //     </Modal.Header>
            //     <Modal.Body>
            //         <Form onSubmit={(e) => e.preventDefault()}>
            //             <Form.Group controlId="formBasicPassword">
            //                 <Form.Label>Password</Form.Label>
            //                 <Form.Control type="password" placeholder="Password" name="password" value={password} onChange={setPassword} />
            //             </Form.Group>
            //         </Form>
            //     </Modal.Body>
            //     <Modal.Footer>
            //         {<><button type="button" className="btn btn-grey" onClick={handleClose} disabled={__btnClicked}>
            //             Cancel
            //         </button>
            //             <button type="button" className="btn btn-orange" onClick={(e) => { !__btnClicked ? submitPassword() : e.preventDefault() }}>
            //                 {__btnClicked ? "Please Wait..." : "Continue"}
            //             </button></>}
            //     </Modal.Footer>
            // </Modal>
        );
    }
}

export default MeetPassword;
